import { Pipe, PipeTransform } from '@angular/core';

import { NodeInputDataType } from '../../viewmodels/node-input';

@Pipe({
  name: 'nodeInputDataType',
})
export class NodeInputDataTypePipe implements PipeTransform {

  transform(value: NodeInputDataType, args?: any): string {
    switch (value) {
      case NodeInputDataType.ProbabilityCategory: {
        return 'Probability Category';
      }
      case NodeInputDataType.ConsequenceCategory: {
        return 'Consequence Category';
      }
      default: {
        return NodeInputDataType[value];
      }
    }
  }
}
